import React, { useState, useEffect, useRef } from 'react';
import { API_URL } from '../../config';
import { X, Download, Upload, Clock, CheckCircle, Play, FileSpreadsheet, Trash2, RefreshCcw, Archive } from 'lucide-react';

export default function ExpansionTasks() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const fileInputRef = useRef(null);
  const [activeTaskId, setActiveTaskId] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showRecycleBin, setShowRecycleBin] = useState(false);

  const fetchTasks = async () => {
    try {
      const token = localStorage.getItem('token') || '';
      const url = `${API_URL}/expansion-tasks${showRecycleBin ? '?status=DELETED' : ''}`;
      const res = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      setTasks(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
    const interval = setInterval(fetchTasks, 15000);
    return () => clearInterval(interval);
  }, [showRecycleBin]);

  const handleDownload = (id) => {
    const token = localStorage.getItem('token') || '';
    window.location.href = `${API_URL}/expansion-tasks/${id}/download?token=${token}`;
    setTimeout(fetchTasks, 2000); // refresh status after download
  };

  const handleUploadClick = (id) => {
    setActiveTaskId(id);
    setShowUploadModal(true);
  };

  
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragOver(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      processUpload(e.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      processUpload(e.target.files[0]);
    }
  };

  const processUpload = async (file) => {
    if (!file || !activeTaskId) return;
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/expansion-tasks/${activeTaskId}/upload`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      
      if (res.ok) {
        alert('上传成功！客户端核聚变按钮已激活。');
        fetchTasks();
        setShowUploadModal(false);
      } else {
        alert('上传失败，请重试');
      }
    } catch (err) {
      alert('上传异常: ' + err.message);
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = null;
      setUploading(false);
      setActiveTaskId(null);
    }
  };


  
  
  const [showCleansingModal, setShowCleansingModal] = useState(false);
  const [cleansingData, setCleansingData] = useState(null);
  
  const handleStartDistill = async (id) => {
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/expansion-tasks/${id}/ai-distill`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        alert('AI提纯已启动，请等待几分钟后台处理');
        fetchTasks();
      } else {
        alert('启动提纯失败');
      }
    } catch (e) {
      alert('异常: ' + e.message);
    }
  };

  const handleOpenCleansingDesk = (task) => {
    setActiveTaskId(task.id);
    try {
      const data = JSON.parse(task.expandedData);
      if (data.distilled) {
         setCleansingData(data.distilled);
         setShowCleansingModal(true);
      }
    } catch(e) {
      console.error(e);
      alert('数据解析失败');
    }
  };

  const handleInjectToMatrix = async () => {
    if (!activeTaskId || !cleansingData) return;
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/expansion-tasks/${activeTaskId}/inject`, {
        method: 'POST',
        headers: { 
           'Content-Type': 'application/json',
           'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify({
           categories: cleansingData.categories,
           needs: cleansingData.needs
        })
      });
      if (res.ok) {
        alert('成功注入意图矩阵！');
        setShowCleansingModal(false);
        fetchTasks();
      }
    } catch (e) {
      alert('注入异常: ' + e.message);
    }
  };


  const handleDelete = async (id) => {
    if (!window.confirm(showRecycleBin ? '确定要永久删除该任务吗？此操作不可恢复。' : '确定要将该任务移至回收站吗？')) return;
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/expansion-tasks/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        fetchTasks();
      } else {
        alert('删除失败');
      }
    } catch (err) {
      alert('删除异常: ' + err.message);
    }
  };

  const handleRestore = async (id) => {
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/expansion-tasks/${id}/restore`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        fetchTasks();
      } else {
        alert('恢复失败');
      }
    } catch (err) {
      alert('恢复异常: ' + err.message);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'PENDING':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400"><Clock className="w-3 h-3 mr-1" /> 待处理</span>;
      case 'PROCESSING':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400"><Play className="w-3 h-3 mr-1" /> 处理中</span>;
      case 'CLEANSING':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400"><RefreshCcw className="w-3 h-3 mr-1 animate-spin" /> AI提纯中</span>;
      case 'CLEANSING_READY':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400"><CheckCircle className="w-3 h-3 mr-1" /> 提纯就绪</span>;
      case 'COMPLETED':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400"><CheckCircle className="w-3 h-3 mr-1" /> 已完成注入</span>;
      case 'DELETED':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400"><Trash2 className="w-3 h-3 mr-1" /> 已删除</span>;
      default:
        return <span>{status}</span>;
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto animate-in fade-in duration-200">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100">{showRecycleBin ? '回收站 (Recycle Bin)' : '拓词调度舱 (Expansion Desk)'}</h1>
          <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">{showRecycleBin ? '已删除的拓词任务，再次删除将永久清除。' : '处理客户提交的种子词，拓展词汇与检索量并回传闭环。'}</p>
        </div>
        <button 
          onClick={() => setShowRecycleBin(!showRecycleBin)}
          className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm font-medium text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors shadow-sm"
        >
          {showRecycleBin ? <FileSpreadsheet className="w-4 h-4" /> : <Archive className="w-4 h-4" />}
          {showRecycleBin ? '返回调度舱' : '回收站'}
        </button>
      </div>



      <div className="bg-white dark:bg-slate-800 shadow-sm rounded-xl border border-gray-200 dark:border-slate-700 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-500 dark:text-slate-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-slate-900/50 dark:text-slate-300">
              <tr>
                <th className="px-6 py-4">任务ID</th>
                <th className="px-6 py-4">项目归属</th>
                <th className="px-6 py-4">状态</th>
                <th className="px-6 py-4">认领人</th>
                <th className="px-6 py-4">创建时间</th>
                <th className="px-6 py-4 text-right">操作</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="6" className="px-6 py-8 text-center">加载中...</td></tr>
              ) : tasks.length === 0 ? (
                <tr><td colSpan="6" className="px-6 py-8 text-center">暂无拓词任务</td></tr>
              ) : (
                tasks.map(task => (
                  <tr key={task.id} className="border-b border-gray-100 dark:border-slate-700/50 hover:bg-gray-50 dark:hover:bg-slate-800/50 transition-colors">
                    <td className="px-6 py-4 font-medium text-gray-900 dark:text-slate-200">#{task.id}</td>
                    <td className="px-6 py-4">{task.brandProject?.name || '未知项目'}</td>
                    <td className="px-6 py-4">{getStatusBadge(task.status)}</td>
                    <td className="px-6 py-4">{task.assignee?.name || '-'}</td>
                    <td className="px-6 py-4">{new Date(task.createdAt).toLocaleString()}</td>
                    <td className="px-6 py-4 text-right">
                      <div className="flex items-center justify-end space-x-3">
                        {!showRecycleBin ? (
                          <>
                            <button 
                              onClick={() => handleDownload(task.id)}
                              className="flex items-center text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 bg-indigo-50 hover:bg-indigo-100 dark:bg-indigo-500/10 dark:hover:bg-indigo-500/20 px-3 py-1.5 rounded-md transition-colors"
                            >
                              <FileSpreadsheet className="w-4 h-4 mr-1" /> 下载种子
                            </button>
                            
                            
                            {(task.status === 'PROCESSING' || task.status === 'PENDING') && (
                              <button 
                                onClick={() => handleUploadClick(task.id)}
                                className="flex items-center text-white bg-indigo-600 hover:bg-indigo-700 px-3 py-1.5 rounded-md transition-colors shadow-sm"
                              >
                                <Upload className="w-4 h-4 mr-1" /> 上传回传
                              </button>
                            )}
                            
                            {task.status === 'COMPLETED' && task.expandedData && !task.expandedData.includes('distilled') && (
                              <button 
                                onClick={() => handleStartDistill(task.id)}
                                className="flex items-center text-white bg-purple-600 hover:bg-purple-700 px-3 py-1.5 rounded-md transition-colors shadow-sm"
                              >
                                <Play className="w-4 h-4 mr-1" /> AI 原子提纯
                              </button>
                            )}

                            {task.status === 'CLEANSING_READY' && (
                              <>
                                <button 
                                  onClick={() => handleStartDistill(task.id)}
                                  className="flex items-center text-purple-600 hover:text-purple-700 bg-purple-50 hover:bg-purple-100 dark:bg-purple-900/30 dark:hover:bg-purple-900/50 dark:text-purple-400 px-3 py-1.5 rounded-md transition-colors shadow-sm"
                                  title="重新提纯"
                                >
                                  <RefreshCcw className="w-4 h-4 mr-1" /> 重新提纯
                                </button>
                                <button 
                                  onClick={() => handleOpenCleansingDesk(task)}
                                className="flex items-center text-white bg-emerald-600 hover:bg-emerald-700 px-3 py-1.5 rounded-md transition-colors shadow-sm"
                              >
                                <CheckCircle className="w-4 h-4 mr-1" /> 数据提纯工作台
                              </button>
                              </>
                            )}

                            
                            <button 
                              onClick={() => handleDelete(task.id)}
                              className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-md transition-colors"
                              title="移至回收站"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </>
                        ) : (
                          <>
                            <button 
                              onClick={() => handleRestore(task.id)}
                              className="flex items-center text-emerald-600 hover:text-emerald-800 dark:text-emerald-400 dark:hover:text-emerald-300 bg-emerald-50 hover:bg-emerald-100 dark:bg-emerald-500/10 dark:hover:bg-emerald-500/20 px-3 py-1.5 rounded-md transition-colors"
                            >
                              <RefreshCcw className="w-4 h-4 mr-1" /> 恢复任务
                            </button>
                            <button 
                              onClick={() => handleDelete(task.id)}
                              className="flex items-center text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 bg-red-50 hover:bg-red-100 dark:bg-red-500/10 dark:hover:bg-red-500/20 px-3 py-1.5 rounded-md transition-colors"
                            >
                              <Trash2 className="w-4 h-4 mr-1" /> 永久删除
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Upload Drag & Drop Modal */}
      
      {/* Data Cleansing Desk Modal */}
      {showCleansingModal && cleansingData && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-5xl h-[85vh] flex flex-col border border-gray-100 dark:border-slate-700 overflow-hidden animate-in zoom-in-95 duration-200">
            <div className="flex justify-between items-center p-5 border-b border-gray-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/50">
              <div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-slate-100 flex items-center gap-2">
                  <Play className="w-5 h-5 text-emerald-500" />
                  数据提纯工作台 (Data Cleansing Desk)
                </h3>
                <p className="text-xs text-slate-500 mt-1">AI已完成原子提纯与搜索量聚合映射。请确认后注入系统矩阵。</p>
              </div>
              <div className="flex items-center gap-3">
                <button 
                  onClick={() => {
                    setShowCleansingModal(false);
                    handleStartDistill(activeTaskId);
                  }}
                  className="flex items-center gap-2 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium shadow-sm transition-colors"
                >
                  <RefreshCcw className="w-4 h-4" /> 重新提纯
                </button>
                <button 
                  onClick={handleInjectToMatrix}
                  className="flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-medium shadow-sm transition-colors"
                >
                  <CheckCircle className="w-4 h-4" /> 注入意图矩阵
                </button>
                <button 
                  onClick={() => setShowCleansingModal(false)}
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 bg-white dark:bg-slate-800 p-2 rounded-lg border dark:border-slate-700"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
            
            <div className="flex-1 flex overflow-hidden">
              {/* Left Panel: Atoms */}
              <div className="w-1/2 border-r border-slate-200 dark:border-slate-700 overflow-y-auto p-5 bg-slate-50 dark:bg-slate-900/20">
                <h4 className="font-bold text-slate-700 dark:text-slate-300 mb-4 flex items-center gap-2"><div className="w-2 h-2 rounded-full bg-blue-500"></div>提取出的【品类】原子 (Category Atoms)</h4>
                <div className="space-y-3 mb-8">
                  {cleansingData.categories.map((c, idx) => (
                    <div key={idx} className="bg-white dark:bg-slate-800 p-4 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm">
                      <div className="flex justify-between items-center mb-2">
                        <span className="font-bold text-blue-700 dark:text-blue-400 text-lg">{c.name}</span>
                        <span className="bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 px-2 py-1 rounded text-xs font-mono font-medium">
                          聚合热力值: {c.volume.toLocaleString()}
                        </span>
                      </div>
                      <div className="text-xs text-slate-500 line-clamp-2">
                        来源包含: {c.keywords.slice(0, 5).join(', ')}{c.keywords.length > 5 ? '...' : ''} ({c.keywords.length}条)
                      </div>
                    </div>
                  ))}
                </div>

                <h4 className="font-bold text-slate-700 dark:text-slate-300 mb-4 flex items-center gap-2"><div className="w-2 h-2 rounded-full bg-orange-500"></div>提取出的【需求】原子 (Need Atoms)</h4>
                <div className="space-y-3">
                  {cleansingData.needs.map((n, idx) => (
                    <div key={idx} className="bg-white dark:bg-slate-800 p-4 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm">
                      <div className="flex justify-between items-center mb-2">
                        <span className="font-bold text-orange-700 dark:text-orange-400 text-lg">{n.name}</span>
                        <span className="bg-orange-50 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 px-2 py-1 rounded text-xs font-mono font-medium">
                          聚合热力值: {n.volume.toLocaleString()}
                        </span>
                      </div>
                      <div className="text-xs text-slate-500 line-clamp-2">
                        来源包含: {n.keywords.slice(0, 5).join(', ')}{n.keywords.length > 5 ? '...' : ''} ({n.keywords.length}条)
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Panel: Info/Traceability */}
              <div className="w-1/2 p-6 flex flex-col justify-center items-center text-center bg-white dark:bg-slate-800">
                 <div className="w-24 h-24 bg-emerald-50 dark:bg-emerald-900/20 rounded-full flex items-center justify-center mb-6">
                    <CheckCircle className="w-12 h-12 text-emerald-500" />
                 </div>
                 <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-200 mb-2">原子提纯计算完成</h2>
                 <p className="text-slate-500 dark:text-slate-400 max-w-md leading-relaxed">
                   系统已将原始搜索长尾词成功剥离为绝对的原子维度，并完美映射了百度和小红书的底层搜索热力值。
                   <br/><br/>
                   注入矩阵后，PRIME L1-L5交叉计算将具备真实的“市场意图价值”数据依据。
                 </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {showUploadModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm">
          <div className="bg-white dark:bg-slate-800 rounded-xl shadow-xl w-full max-w-md overflow-hidden flex flex-col border border-gray-100 dark:border-slate-700">
            <div className="flex justify-between items-center p-5 border-b border-gray-100 dark:border-slate-700">
              <h3 className="font-bold text-gray-900 dark:text-slate-100 flex items-center gap-2">
                <Upload className="w-5 h-5 text-indigo-500" />
                上传已处理的回传文件
              </h3>
              <button 
                onClick={() => setShowUploadModal(false)}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-6">
              <input 
                type="file" 
                ref={fileInputRef} 
                style={{ display: 'none' }} 
                accept=".xlsx, .xls, .csv" 
                onChange={handleFileChange}
              />
              
              <div 
                onDragOver={handleDragOver} 
                onDragLeave={handleDragLeave} 
                onDrop={handleDrop}
                onClick={() => fileInputRef.current?.click()}
                className={`w-full flex flex-col items-center justify-center py-10 border-2 border-dashed rounded-xl transition-colors cursor-pointer group ${isDragOver ? "bg-indigo-50 border-indigo-500 dark:bg-indigo-900/30 dark:border-indigo-400" : "border-gray-300 dark:border-slate-600 hover:bg-gray-50 dark:hover:bg-slate-700/50 hover:border-indigo-400"}`}
              >
                <div className="p-3 bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 rounded-full mb-3 group-hover:scale-110 transition-transform">
                  <FileSpreadsheet className="w-8 h-8" />
                </div>
                <span className="font-medium text-gray-700 dark:text-gray-300">点击或拖拽上传 Excel 文件</span>
                <span className="text-xs text-gray-500 dark:text-gray-400 mt-2">支持 .xlsx, .xls, .csv 格式，处理后的种子词表</span>
                
                {uploading && (
                  <div className="mt-4 text-indigo-600 dark:text-indigo-400 text-sm font-medium animate-pulse">
                    正在上传处理中...
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
